import { render } from "./ModalGroups.vue?vue&type=template&id=83b22aba"
import script from "./ModalGroups.vue?vue&type=script&lang=js"
export * from "./ModalGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__